import { InvoiceStatusNameValueEnum } from '../enum/invoice.enum';
import { BaseDto } from './base.dto';

export class InvoiceStatusCountResultDto extends BaseDto {
  type: InvoiceStatusNameValueEnum;
  count: number;
}
